/**
 * Default address form object
 */
export const defaultAddress = {
  streetAddress1: '',
  streetAddress2: '',
  city: '',
  stateProvinceId: '',
  postalCode: '',
  countryId: '',
  isBilling: false,
  addressType: 'invoice'
};

/**
 * Default contact form object
 */
export const defaultFormData = {
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
  companyId: '',
  titleId: '',
  function: '',
  type: 'individual',
  vat: '',
  internalNote: '',
  lang: '',
  tags: [],
  addresses: [],
  customer: false,
  vendor: false,
  landlord: false,
  salesPersonId: '',
  parentCompanyName: null,
  parentCompanyAddresses: [],
  childContacts: []
};
